// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"main-layout_wrapper__bRsBn"};